import { computed, defineComponent, ref, useCssModule, useRoute } from '@nuxtjs/composition-api';
import { IS_DEBUG_MODE, SHOULD_DISABLE } from '~/plugins/adfox';
import { randomNumber } from '~/utils';
export default defineComponent({
    name: 'RotatingBanner',
    props: {
        config: {
            required: true,
            type: Object,
        },
    },
    emits: ['complete'],
    setup(_, { emit }) {
        /**
         * CSS Modules.
         */
        const css = useCssModule();
        const route = useRoute();
        const { rotatingBanner = '' } = route.value.query;
        const shouldRender = computed(() => {
            return !SHOULD_DISABLE && (process.env.NODE_ENV !== 'development' || IS_DEBUG_MODE);
        });
        /**
         * Случайное число в пределах 100%
         */
        const randomIndex = ref(randomNumber(1, 200));
        /**
         * Условие показа adfox
         */
        const shouldShowAdfox = computed(() => {
            if (rotatingBanner) {
                // ?rotatingBanner=adfox
                return rotatingBanner === 'adfox';
            }
            // 50% (100 от 200)
            return randomIndex.value <= 100;
        });
        /**
         * Условие показа sparrow
         */
        const shouldShowSparrow = computed(() => {
            if (rotatingBanner) {
                // ?rotatingBanner=sparrow
                return rotatingBanner === 'sparrow';
            }
            // 37.5% (75% от 50% / 75 от 100)
            return randomIndex.value > 100 && randomIndex.value <= 175;
        });
        /**
         * Условие показа infox
         */
        const shouldShowInfox = computed(() => {
            if (rotatingBanner) {
                // ?rotatingBanner=infox
                return rotatingBanner === 'infox';
            }
            // 12.5% (25% от 50% / 25 от 100)
            return randomIndex.value > 175;
        });
        function onComplete({ error = {}, state }) {
            emit('complete', { error, state });
        }
        return {
            css,
            onComplete,
            randomIndex,
            shouldRender,
            shouldShowAdfox,
            shouldShowSparrow,
            shouldShowInfox,
        };
    },
});
